export const BENEFICIOS_VOUCHERS_PERMISSIONS = Object.freeze({
	VIEW: 64,
	EDIT: 65,
	CHANGE_STATUS: 66,
	DELETE: 67,
	INVOICE: 68,
	MANAGE_BILLING_CLIENTS: 69,
});

export const BENEFICIOS_VOUCHERS_PERMISSION_IDS = Object.freeze(
	Object.values(BENEFICIOS_VOUCHERS_PERMISSIONS)
);
